import expireIn from 'lib/redux-persist-transform'
import { combineReducers } from 'redux'
import { getPersistConfig } from 'redux-deep-persist'
import { MigrationManifest } from 'redux-persist'
import createMigrate from 'redux-persist/es/createMigrate'
import persistReducer from 'redux-persist/es/persistReducer'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

import { ILastWinsState } from '../types'
import communications from './communications'
import data from './data'
import { lastWinsMigrations } from './migrations/migrations'

const reducedWithComm = combineReducers<ILastWinsState>({
  communications,
  data,
})

const expireInValue = 2 * 60 * 60 * 1000
const expirationKey = 'expirationKeyTransform'

const persistConfig = getPersistConfig({
  key: 'lastWins',
  storage,
  version: 1,
  blacklist: ['communications'],
  migrate: createMigrate(lastWinsMigrations as unknown as MigrationManifest, { debug: false }),
  rootReducer: reducedWithComm,
  transforms: [expireIn(expireInValue, expirationKey, [])],
})

export const reducer = persistReducer(persistConfig, reducedWithComm)
